import React, { useContext, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch } from 'react-redux';

import authContext from '../../context/authContext/authContext';
import Loader from '../../utils/Loader';
import { selectProductAction } from '../../redux/actions/productsAction';
import axios from 'axios';
import errorHandle from '../../utils/errorHandle';
import successHandle from '../../utils/successHandle';

const RATE_PARTNER_END_POINT = process.env.REACT_APP_API_URL + "/api/user/rate";


const ratingOptions = Array.from({ length: 9 }, (_, i) => {
  const value = 1 + i * 0.5;
  return {
    value,
    label: `${value} ⭐`
  };
});

const initialState = { loading: false, partnerRating: '' }

const RatingModal = ({ isOpen, toggle , getUser}) => {
  const { getConfig } = useContext(authContext);
  const config = getConfig();

  const [state, setCompleteState] = useState(initialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const onHideModal = () => {
    setState(initialState)
    toggle();
  }

  const handleSubmit = () => {
    if(!state.partnerRating) {
      return;
    }

    ratePartner();
  }


  const ratePartner = async () =>  {
    setState({ loading: true })
    const { partnerRating } = state;
    const data = { partnerRating: Number(partnerRating) }
    await axios.post(RATE_PARTNER_END_POINT, data, config)
      .then((res) => {
        setState({ loading: false })
        successHandle(res.data.message);
        onHideModal();
        getUser()
      })
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  } 

  return (
    <Modal isOpen={isOpen} toggle={onHideModal}>
      <ModalHeader toggle={onHideModal}>
        <div className='d-flex align-items-center'>
          <div className='fw-600'>Partner Rating</div>
          <div className='ml-3'>
            <Loader isLoading={state.loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='row'>
          <div className='col-md-6 mb-4'>
            <div>Rate your partner to share feedback, improve service quality, build trust, recognize performance, and help create better partnerships across the platform.</div>
          </div>

          <div className='col-md-6 mb-4'>
            <div class="form-group">
              <ladbel class="">Choose Rating</ladbel>
              <div class="input-group mt-2">
                <select class="custom-product-select w-100" value={state.partnerRating} onChange={(e) => setState({ partnerRating: Number(e.target.value) })}>
                  <option value="">Choose...</option>
                  {ratingOptions?.map((rating) => {
                    return (
                      <option value={rating.value} selected={state.partnerRating === rating.value}>{rating.label}</option>
                    )
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={state.loading}>
          Cancel
        </Button>
        <Button color="gleamdesk" onClick={handleSubmit} disabled={state.loading || !state.partnerRating}>
          Rate
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default RatingModal
